import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { ContractItem, Contract } from '../models';

export class ContractApi extends ApiModule {
  protected endpoint = '/contract';

  public async pageContracts(params: any) {
    return this.api.post<PaginatedResponseData<ContractItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadContractDetails(id: number) {
    return this.api.get<Contract>(`${this.endpoint}?id=${id}`);
  }

  public saveContract(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteContract(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
